import { ResourceBuilder } from '@salsita-ai/platform-project-sdk/domain';
export const resources = new ResourceBuilder().addLink({
    type: 'ConfigurationLink',
    name: 'readLink'
}).addClientGeneratedImage({
    type: 'Image',
    name: 'thumbnail',
    s3Key: 'thumbnail',
    clientGenerated: true
}).addClientGeneratedImage({
    type: 'Image',
    name: 'main',
    s3Key: 'main',
    clientGenerated: true
}).build();

//# sourceMappingURL=resources.js.map